import { IAuthService, IProfile } from "./auth/interfaces";
import { IApplicationService } from "./interfaces";
import { IProjectService } from "./project/interfaces";

export default class ApplicationService implements IApplicationService {
  public authenticateUser: any;
  public setLoadStatus: any;
  private authService: IAuthService;
  private projectService: IProjectService;
  public constructor(auth: IAuthService, projectService: IProjectService) {
    this.authService = auth;
    this.projectService = projectService;
  }

  public getAuthService(): IAuthService {
    return this.authService;
  }
  public App(): firebase.app.App {
    return this.getAuthService().App();
  }
  public getProjectService(): IProjectService {
    throw new Error("Method not implemented.");
  }
  public login(email: string, password: string): Promise<firebase.auth.UserCredential> {
    return this.authService.login(email, password);
  }
  public register(email: string, password: string): Promise<firebase.auth.UserCredential> {
    return this.authService.register(email, password);
  }
  public setUser(user: any, firstName?: string, lastName?: string): Promise<any> {
    return this.authService.setUser(user, firstName, lastName);
  }
  public authenticate(): void {
    this.authService.authenticate();
  }
  public isAuthenticated(): boolean {
    return this.authService.isAuthenticated();
  }
  public getAccessToken(): string {
    return this.authService.getAccessToken();
  }
  public getUserProfileId(): string {
    return this.authService.getUserProfileId();
  }
  public getProfile(): IProfile {
    return this.authService.getProfile();
  }
  public logout(history: any): Promise<void> {
    return this.authService.logout(history);
  }
  public isProjectActive(): boolean {
    return this.projectService.isProjectActive();
  }
  public isProjectIdActive(id: string): boolean {
    return this.projectService.isProjectIdActive(id);
  }
  public setActiveProject(id: string, projectLocation: string): void {
    this.projectService.setActiveProject(id, projectLocation);
  }
  public resetActiveProject(): void {
    this.projectService.resetActiveProject();
  }
  public getActiveProjectId(): string {
    return this.projectService.getActiveProjectId();
  }
  public getActiveProjectLocation(): string {
    return this.projectService.getActiveProjectLocation();
  }
  public copyProject(sourceId: string, id: string): void {
    this.projectService.copyProject(sourceId, id);
  }
}



// WEBPACK FOOTER //
// ./src/services/applicationService.tsx